import api from '../token';

export const AddProcessoEntradaEstoque = async (dados) => {
  try {
    const response = await api.post('/entradaEstoque', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
